import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'penetration_testings'

const TESTING_STATUS_LABELS = {
  in_progress: 'En progreso',
  in_review: 'En revisión',
  canceled: 'Cancelado',
  rejected: 'Rechazado',
  reopened: 'Reabierto',
  approved: 'Aprobado',
}

const testingStatusMapItem = item => {
  const v = Object.values(item)[0]
  return { value: v, label: TESTING_STATUS_LABELS[v] || v }
}

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: { label: 'REMS' },
  MUNICIPALITY: {},
  STATUS: {
    column: 'testing_status.name',
    label: 'Estatus',
    optionsOverrides: { mapItem: testingStatusMapItem },
  },
  REGION: { column: 'regions.name', label: 'Estado' },
  SECTOR: { column: 'sectors.name', label: 'Región' },
  CENTER: false,
  TENANT: false,
  USER: { label: 'Usuario' },
})

export default {
  key: DATASET_KEY,
  label: 'Pruebas de penetración',
  timeColumn: 'penetration_testings.created_at',
  permission: { action: 'read', subject: 'Testing' },

  tables: {
    penetration_testings: ["id", "id_unit", "reference_number", "registration_date", "stage_manager", "scenario_type", "event_type", "hypothesis_description", "details_description", "result", "files", "suggested_actions", "corrective_actions", "created_at", "updated_at"],
    penetration_testing_users: ["id", "id_penetration_testing", "name", "position", "soeid", "type", "created_at", "updated_at"],
    view_latest_penetration_testing_status: ["id", "id_penetration_testing", "id_status", "id_user", "id_user_validation", "comments", "approved_at", "rejected_at", "reopened_at", "canceled_at", "created_at", "updated_at"],
    testing_status: ["id", "name", "created_at", "updated_at"],
    users: ["id", "id_unit", "id_maintenance_company", "image", "check_alarms", "frame_color", "id_profile", "user", "email", "password", "name", "first_name", "second_name", "config", "plate_number", "created", "updated", "active", "vpn_access", "allow_virtual_button_alarm", "allow_visual_notifications", "allowed_units_live_video_flows", "phone_number", "alarm_history_per_hours", "alarm_history_per_days", "alarm_history_by_records", "last_login", "video_wall", "active_sesion_video_wall", "id_country", "auth_two_factor_code", "auth_two_factor_time", "auth_two_factor_type", "verify_email_code", "verify_sms_code", "verify_sms", "verify_email", "online", "enabled_chat", "enabled_helpdesk"],
    units: ["id", "id_router", "description", "address_1", "address_2", "exterior_number", "suburb", "number", "postal_code", "id_country", "id_region", "id_sector", "active", "route", "plate_number", "vin", "driver", "provider", "owner", "company", "vehicle", "allow_virtual_button_alarm", "reaction_patrol", "id_alarms_levels", "active_digital_output", "needs_check", "id_municipality", "time_zone", "data", "comments", "id_category", "id_seproban", "rems", "sirh", "created_at", "updated_at"],
    sectors: ["id", "id_center", "name", "alcaldia", "provider", "created", "updated"],
    regions: ["id", "name", "code", "country_id", "acronym", "created_at", "updated_at"],
    centers: ["id", "tenant_id", "name", "description", "updated", "created", "active"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'units.description',
    // field2: 'testing_status.name',
  },

  csvConfig: {
    withTables: 'penetration_testings',
    columns: 'penetration_testings.reference_number,penetration_testings.registration_date,penetration_testings.stage_manager,penetration_testings.scenario_type,penetration_testings.event_type,penetration_testings.hypothesis_description,penetration_testings.details_description,penetration_testings.result,penetration_testings.files,penetration_testings.suggested_actions,penetration_testings.corrective_actions,penetration_testings.created_at,penetration_testings.updated_at,view_latest_penetration_testing_status.comments,view_latest_penetration_testing_status.approved_at,view_latest_penetration_testing_status.rejected_at,view_latest_penetration_testing_status.reopened_at,view_latest_penetration_testing_status.canceled_at,view_latest_penetration_testing_status.created_at,view_latest_penetration_testing_status.updated_at,units.description,units.active,sectors.provider,centers.name,municipalities.name,sectors.name,regions.name',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'units.description', label: 'REMS' },
    { key: 'users.name', label: 'Usuario' },
    { key: 'users.id_profile', label: 'Perfil' },
    { key: 'regions.name', label: 'Estado' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'penetration_testings.scenario_type', label: 'Tipo de escenario' },
    { key: 'penetration_testings.event_type', label: 'Tipo de evento' },
    { key: 'penetration_testings.result', label: 'Resultado' },
    { key: 'penetration_testings.stage_manager', label: 'Responsable del ejercicio' },
    { key: 'penetration_testings.registration_date', label: 'Fecha registro', defaultParams: { freq: '1mo' } },
    { key: 'penetration_testings.created_at', label: 'Fecha de creación', defaultParams: { freq: '1mo' } },
    { key: 'penetration_testings.updated_at', label: 'Fecha de actualización', defaultParams: { freq: '1mo' } },
    { key: 'penetration_testing_users.name', label: 'Nombre (usuario prueba)' },
    { key: 'penetration_testing_users.position', label: 'Posición (usuario prueba)' },
    { key: 'penetration_testing_users.type', label: 'Tipo de usuario (prueba)' },
    { key: 'penetration_testing_users.created_at', label: 'Fecha de creación (Usuario prueba)', defaultParams: { freq: '1mo' } },
    { key: 'penetration_testing_users.updated_at', label: 'Fecha de actualización (Usuario prueba)', defaultParams: { freq: '1mo' } },
    { key: 'testing_status.name', label: 'Estatus' },
    { key: 'view_latest_penetration_testing_status.approved_at', label: 'Fecha de aprobación', defaultParams: { freq: '1mo' } },
    { key: 'view_latest_penetration_testing_status.rejected_at', label: 'Fecha de rechazo', defaultParams: { freq: '1mo' } },
    { key: 'view_latest_penetration_testing_status.reopened_at', label: 'Fecha de reapertura', defaultParams: { freq: '1mo' } },
    { key: 'view_latest_penetration_testing_status.canceled_at', label: 'Fecha de cancelación', defaultParams: { freq: '1mo' } },
    { key: 'view_latest_penetration_testing_status.created_at', label: 'Fecha de creación (Estado prueba)', defaultParams: { freq: '1mo' } },
    { key: 'view_latest_penetration_testing_status.updated_at', label: 'Fecha de actualización (Estado prueba)', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'penetration_testings.scenario_type', 'Tipo de escenario', 'level'),
    embedFilter(DATASET_KEY, 'penetration_testings.event_type', 'Tipo de evento', 'type'),
    embedFilter(DATASET_KEY, 'penetration_testings.result', 'Resultado', 'result'),
    embedFilter(DATASET_KEY, 'penetration_testing_users.soeid', 'SOEID (usuario prueba)', 'user_soeid'),
    embedFilter(DATASET_KEY, 'penetration_testings.stage_manager', 'Responsable del ejercicio', 'stage_manager'),
    embedFilter(DATASET_KEY, 'penetration_testing_users.type', 'Tipo de usuario (prueba)', 'user_type_testing'),
    embedFilter(DATASET_KEY, 'view_latest_penetration_testing_status.comments', 'Comentarios (Estado prueba)', 'status_comments'),
    {
      key: 'time',
      label: 'Fecha registro',
      filterType: 'where-date',
      whereColumn: 'penetration_testings.registration_date',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'penetration_testings_updated_at',
      label: 'Fecha de actualización',
      filterType: 'where-date',
      whereColumn: 'penetration_testings.updated_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'approved_at',
      label: 'Fecha de aprobación',
      filterType: 'where-date',
      whereColumn: 'view_latest_penetration_testing_status.approved_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'rejected_at',
      label: 'Fecha de rechazo',
      filterType: 'where-date',
      whereColumn: 'view_latest_penetration_testing_status.rejected_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'reopened_at',
      label: 'Fecha de reapertura',
      filterType: 'where-date',
      whereColumn: 'view_latest_penetration_testing_status.reopened_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'canceled_at',
      label: 'Fecha de cancelación',
      filterType: 'where-date',
      whereColumn: 'view_latest_penetration_testing_status.canceled_at',
      optionsConfig: { type: 'date' },
    },
  ],

  dateGrouping: {
    column: 'penetration_testings.registration_date',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
